
export type IdOptions = "author" | "xbot" | "op";

export enum IdOptionsEnum {
	author= "author", 
	xbot = "xbot",
	op = "op"
} 


/*
	PRO FSM stav
*/
export enum GlobalStateEnum {
	BOT_ONLINE = "BOT_ONLINE",
	BOT_OFFLINE = "BOT_OFFLINE", //stav pred login a v pripade nedostupnosti
	OP_ONLINE = "OP_ONLINE",
	OP_OFFLINE = "OP_OFFLINE",
	OP_BUSY = "OP_BUSY"
}



export interface IWelcomeMessage {
	welcomeMessage: string
	popupMessage: string
	inputFieldPlaceholder: string
	clientAvatar: string
	waAvatar: string
	disambigText: string
	notUnderstandText: string
	errorText: string
	maxInput: number
}
export interface IMessageFrom {
	avatar: string
	id: IdOptions
	name: string
	photo: string
}

export interface IMessage {
	message: string[]
	message2: string[]
	from: IMessageFrom
	timeStamp: string
	generic: object
	shouldDisplayButtons: Boolean
	parsedMessage: string
	parsedButtons: string[]
	index: number
	loading: boolean
}

export interface IPayloadToWatson {
	text: string
	timestamp: string
	txStartTimestamp: string
	txEndTimestamp: string
	isLoginTx: Boolean
	channel: string
}

export interface ILogMessage {
	instanceId: string
	parentApp: string
	timestamp: string
	severity: string
	message: string

}